import { render, staticRenderFns } from "./Partidas.view.vue?vue&type=template&id=3d5daafc"
import script from "./Partidas.view.vue?vue&type=script&lang=js"
export * from "./Partidas.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports